<template>
    <el-container>
        <el-aside width="25%">
            <h3>{{ $t("posts.edit.contactTitle") }}</h3>
            <p class="text-justify">{{ $t("posts.edit.contactText") }}</p>
        </el-aside>
        <el-container style="width: 100%;">
            <el-main>
                <el-col :span="24">
                    <el-form-item :label="$t('posts.edit.contactFirstnameLastname')">
                        <el-select
                                clearable
                                filterable
                                allow-create
                                default-first-option
                                v-model="contactSelected"
                                @change="changeValue('contact')"
                        >
                            <el-option
                                    style="text-transform:capitalize"
                                    v-for="contact in this.contacts"
                                    :key="contact.id"
                                    :value="contact.id"
                                    :label="contact.fullname"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="user.isUSH">
                    <el-form-item :label="$t('posts.edit.commercialEntityCode')">
                        <el-input v-model="post.id_externe_pdv" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item :label="$labels.email_a_afficher" prop="email_a_afficher">
                        <el-input v-model="post.email_a_afficher" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item :label="$labels.telephone_a_afficher" prop="telephone_a_afficher">
                        <el-input v-model="post.telephone_a_afficher" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item :label="$labels.telephone_mobile_a_afficher" prop="telephone_mobile_a_afficher">
                        <el-input v-model="post.telephone_mobile_a_afficher" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$labels.adresse_contact_a_afficher" prop="adresse_contact_a_afficher">
                    <el-input v-model="post.adresse_contact_a_afficher" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$labels.code_postal_contact_a_afficher" prop="code_postal_contact_a_afficher">
                    <el-input v-model="post.code_postal_contact_a_afficher" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$labels.ville_contact_a_afficher" prop="ville_contact">
                    <el-input v-model="post.ville_contact_a_afficher" />
                  </el-form-item>
                </el-col>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { getUsers } from '@/services/users'
import { mapGetters } from 'vuex'

export default {
  name: 'PostFormContactInfo',
  props: ['create', 'post', 'idUser'],
  data () {
    return {
      contacts: [],
      contactSelected: null,
      chargement: true,
      hasAnnonce: false
    }
  },
  methods: {
    sameContactId (a, b) {
      return a != null && b != null && String(a) === String(b)
    },
    /**
     * Aligne id_contact_a_afficher sur le contact sélectionné, sans toucher aux coordonnées.
     */
    alignPostContactId (contact) {
      if (!contact) {
        return
      }
      if (!this.sameContactId(this.post.id_contact_a_afficher, contact.id)) {
        this.$set(this.post, 'id_contact_a_afficher', contact.id)
      }
    },
    /**
     * Applique un contact résolu : select + champs selon le mode.
     */
    applyResolvedContact (contact) {
      if (!contact) {
        return
      }

      this.contactSelected = contact.id

      if (this.create) {
        this.fillContactFields(contact)
      } else {
        this.fillContactFieldsIfEmpty(contact)
      }
    },
    changeValue (elem) {
      if (elem === 'contact') {
        if (this.contactSelected) {
          const contact = this.contacts.find(x => this.sameContactId(x.id, this.contactSelected))
          if (contact) {
            this.syncContactFieldsFromUser(contact, { force: true })
          }
        } else {
          this.$set(this.post, 'contact_a_afficher', '')
          this.$set(this.post, 'id_contact_a_afficher', '')
        }
      }
    },
    /**
     * Positionne le select contact sans écraser les coordonnées stockées sur l'annonce.
     */
    controleContactSelectionne () {
      if (!this.contacts.length) {
        return
      }

      const contact = this.findContactFromPost()
      if (!contact) {
        return
      }

      this.contactSelected = contact.id
      this.alignPostContactId(contact)
    },
    syncContactFieldsFromUser (contact, { force = false } = {}) {
      if (!contact || (!force && !this.create)) {
        return
      }

      this.$set(this.post, 'id_contact_a_afficher', contact.id)
      this.$set(this.post, 'contact_a_afficher', contact.fullname || '')
      this.$set(this.post, 'email_a_afficher', contact.email || '')
      this.$set(this.post, 'telephone_a_afficher', contact.phone || '')
      this.$set(this.post, 'telephone_mobile_a_afficher', contact.mobile || '')
      this.$set(this.post, 'adresse_contact_a_afficher', contact.address || '')
      this.$set(this.post, 'code_postal_contact_a_afficher', contact.zipcode || '')
      this.$set(this.post, 'ville_contact_a_afficher', contact.city || '')
    },
    // Méthode pour pré-remplir les champs avec réactivité
    fillContactFields (contact) {
      if (!contact) {
        return
      }

      this.$nextTick(() => {
        this.alignPostContactId(contact)
        this.$set(this.post, 'contact_a_afficher', contact.fullname || '')
        this.$set(this.post, 'email_a_afficher', contact.email || '')
        this.$set(this.post, 'telephone_a_afficher', contact.phone || '')
        this.$set(this.post, 'telephone_mobile_a_afficher', contact.mobile || '')
        this.$set(this.post, 'adresse_contact_a_afficher', contact.address || '')
        this.$set(this.post, 'code_postal_contact_a_afficher', contact.zipcode || '')
        this.$set(this.post, 'ville_contact_a_afficher', contact.city || '')
      })
    },
    // En édition: compléter uniquement les champs vides pour éviter d'écraser l'annonce.
    fillContactFieldsIfEmpty (contact) {
      if (!contact) {
        return
      }

      this.alignPostContactId(contact)

      if (!this.post.contact_a_afficher) {
        this.$set(this.post, 'contact_a_afficher', contact.fullname || '')
      }
      if (!this.post.email_a_afficher) {
        this.$set(this.post, 'email_a_afficher', contact.email || '')
      }
      if (!this.post.telephone_a_afficher) {
        this.$set(this.post, 'telephone_a_afficher', contact.phone || '')
      }
      if (!this.post.telephone_mobile_a_afficher) {
        this.$set(this.post, 'telephone_mobile_a_afficher', contact.mobile || '')
      }
      if (!this.post.adresse_contact_a_afficher) {
        this.$set(this.post, 'adresse_contact_a_afficher', contact.address || '')
      }
      if (!this.post.code_postal_contact_a_afficher) {
        this.$set(this.post, 'code_postal_contact_a_afficher', contact.zipcode || '')
      }
      if (!this.post.ville_contact_a_afficher) {
        this.$set(this.post, 'ville_contact_a_afficher', contact.city || '')
      }
    },
    // Méthode pour initialiser les propriétés de façon réactive
    initializePostProperties () {
      const fields = [
        'contact_a_afficher',
        'email_a_afficher',
        'telephone_a_afficher',
        'telephone_mobile_a_afficher',
        'adresse_contact_a_afficher',
        'code_postal_contact_a_afficher',
        'ville_contact_a_afficher'
      ]

      fields.forEach(field => {
        if (!this.post.hasOwnProperty(field)) {
          this.$set(this.post, field, '')
        }
      })
    },
    /**
     * Si l'id stocké sur l'annonce est obsolète mais que le select pointe
     * vers un contact valide, réaligner uniquement id_contact_a_afficher.
     */
    syncPostIdContactIfStale () {
      if (this.create || !this.contactSelected || !this.contacts.length) {
        return
      }

      const idOnPost = this.post.id_contact_a_afficher
      const postIdStillValid = idOnPost != null
        && idOnPost !== ''
        && this.contacts.some(c => this.sameContactId(c.id, idOnPost))

      if (postIdStillValid) {
        return
      }

      const selectedStillValid = this.contacts.some(
        c => this.sameContactId(c.id, this.contactSelected)
      )
      if (selectedStillValid) {
        this.alignPostContactId({ id: this.contactSelected })
      }
    },
    /**
     * Retrouve le contact enregistré sur l'annonce.
     * Priorité : id_contact_a_afficher valide, puis égalité exacte sur fullname (trim).
     */
    findContactFromPost () {
      if (!this.contacts.length) {
        return null
      }

      const idOnPost = this.post.id_contact_a_afficher
      if (idOnPost != null && idOnPost !== '') {
        const byId = this.contacts.find(c => this.sameContactId(c.id, idOnPost))
        if (byId) {
          return byId
        }
      }

      const nameOnPost = String(this.post.contact_a_afficher || '').trim()
      if (nameOnPost) {
        return this.contacts.find(c =>
          (c.fullname || '').trim() === nameOnPost
        ) || null
      }

      return null
    }
  },
  async mounted () {
    // Initialiser les propriétés de façon réactive
    this.initializePostProperties()

    const filtresContacts = { active: true, pagination: false }
    if (this.isSubUser) {
      // SubUser : uniquement lui-même dans la liste de contacts
      filtresContacts.id = this.user.id
    }
    this.contacts = (await getUsers(filtresContacts)).list || []

    if (this.isSubUser) {
      if (this.contacts.length > 0) {
        this.contactSelected = this.contacts[0].id
        this.fillContactFields(this.contacts[0])
      }
      return
    }

    // Priorité 1: contact effectivement enregistré sur l'annonce
    const storedContact = this.findContactFromPost()
    // Priorité 2: idUser fourni par le parent
    const parentContact = this.idUser
      ? this.contacts.find(c => this.sameContactId(c.id, this.idUser))
      : null

    if (storedContact) {
      this.applyResolvedContact(storedContact)
    } else if (parentContact) {
      this.applyResolvedContact(parentContact)
    } else if (this.contacts.length > 0) {
      // Prendre l'utilisateur connecté
      const contact = this.contacts.find(c => this.sameContactId(c.id, this.user.id))
      if (contact) {
        if (this.create || !this.post.contact_a_afficher) {
          this.applyResolvedContact(contact)
        } else {
          this.contactSelected = contact.id
        }
      }
    }

    this.syncPostIdContactIfStale()
  },
  computed: {
    ...mapGetters(['isSubUser']),
    user () {
      return this.$store.getters.getUser
    }
  },
  watch: {
    post: {
      handler (newPost) {
        if (newPost.contact_a_afficher && !this.hasAnnonce) {
          this.hasAnnonce = true
          this.controleContactSelectionne()
        }
      },
      deep: true
    },
    // Watcher pour réagir aux changements de idUser venant du parent (PostEdit.vue)
    idUser (newIdUser) {
      if (!newIdUser || this.sameContactId(newIdUser, this.contactSelected)) {
        return
      }

      const contact = this.contacts.find(c => this.sameContactId(c.id, newIdUser))
      if (!contact) {
        return
      }

      this.contactSelected = contact.id

      if (this.create) {
        this.fillContactFields(contact)
      } else {
        this.fillContactFieldsIfEmpty(contact)
      }

      this.syncPostIdContactIfStale()
    }
  }
}
</script>

<style scoped>

</style>
